module.exports = __webpack_public_path__ + "img/steps-signup-bgr.17abe668.svg";